import { isBrowser } from "react-device-detect";
import AssistButton from "./AssistButton";
import ResumAssistencia from "./assistencia/ResumAssistencia";
import styles from "./Events.styles";
import Info from "./info/Info";
import LlistaProves, { calculateProvesHores } from "./proves/LlistaProves";
import ResumTroncs from "./troncs/ResumTroncs";
import ResumNuclis from "./nuclis/ResumNuclis";
import WebAppTroncs from "./troncs/WebAppTroncs";
import Popup from "../other/Popup";
import { can } from "../../utils/permissions";

import React, { useState } from 'react';
import { applyTimeZone, getSubdomain } from "../../utils/utils";
import { hasNuclisSummaryFeature } from "../../utils/colla-features";
import HideButton from "./info/HideButton";
import Pressable from "../other/Pressable";
import { buildEventAppLink } from "../../utils/eventDeepLinks";

const COLLA = getSubdomain();

function BotoProjector({ event, type }) {
    const [styleState, setStyleState] = useState('normal');

    const styles = {
        boto_projector: {
            display: 'inline-block',
            padding: '10px 20px',
            textDecoration: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            flex: 1,
            marginTop: '10px',
            textAlign: 'center',
            backgroundColor: '#f2f2f2',
            color: '#000',
        },
        input_projector: {
            width: '88%',
            padding: '10px 20px',
            borderRadius: '4px',
            fontSize: '12px',
            transition: 'background-color 0.3s',
            marginTop: '10px',
            textAlign: 'center',
            backgroundColor: '#f2f2f2',
            color: '#000',
            direction: 'rtl'
        }
    };

    const copyToClipboard = async (e) => {
        e.stopPropagation(); // Prevent triggering the input's onClick event
        const textToCopy = `https://${COLLA}.tenimaleta.com/${type}/${event}`;

        try {
          await navigator.clipboard.writeText(textToCopy);
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
    };            

    const handleMouseEnter = () => {
        setStyleState('hover');
    };

    const handleMouseLeave = () => {
        setStyleState('normal');
    };

    const handleMouseDown = () => {
        setStyleState('active');
    };

    const handleMouseUp = () => {
        setStyleState('hover');
    };

    const handleFocus = () => {
        setStyleState('focus');
    };

    const handleBlur = () => {
        setStyleState('normal');
    };

    const [copied, setCopied] = useState(false);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                flexDirection: isBrowser ? 'row' : 'column',
            }}
        >
            <a
                href={`/${type}/${event}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    ...styles.boto_projector,
                }}
                onPointerEnter={handleMouseEnter}
                onPointerLeave={handleMouseLeave}
                onPointerDown={handleMouseDown}
                onPointerUp={handleMouseUp}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
                Entrar a mode projecció 🎥
            </a>

            <div style={{ position: 'relative', flex: 2, display: 'flex', justifyContent: 'center' }}>
                <input
                    onClick={(e) => e.target.select()}
                    type="text"
                    value={`https://${COLLA}.tenimaleta.com/${type}/${event}`}
                    style={{
                        ...styles.input_projector,
                    }}
                    readOnly
                />

                { isBrowser && <button
                    onClick={(e) => {
                        copyToClipboard(e);
                        setCopied(true);
                    }}
                    style={{
                        position: 'absolute',
                        right: 4,
                        top: '60%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#f2f2f2',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        fontSize: '12px',
                        padding: '5px',
                        cursor: 'pointer',
                        color: 'black'
                    }}
                >
                    {copied ? 'Copiat!' : 'Copiar'}
                </button> }
            </div>
        </div>
    );
}

function BotoMobileAppLink({ event, tipus }) {
    const [copied, setCopied] = useState(false);
    const appLink = buildEventAppLink({
        colla: COLLA,
        eventType: tipus,
        eventId: event,
    });

    if (!appLink) return null;

    const styles = {
        boto_app: {
            display: 'inline-block',
            padding: '10px 20px',
            textDecoration: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            transition: 'background-color 0.3s',
            flex: 1,
            marginTop: '10px',
            textAlign: 'center',
            backgroundColor: '#e8f0ff',
            color: '#000',
        },
        input_app: {
            width: '88%',
            padding: '10px 20px',
            borderRadius: '4px',
            fontSize: '12px',
            transition: 'background-color 0.3s',
            marginTop: '10px',
            textAlign: 'center',
            backgroundColor: '#e8f0ff',
            color: '#000',
            direction: 'rtl'
        }
    };

    const copyToClipboard = async (e) => {
        e.stopPropagation();

        try {
            await navigator.clipboard.writeText(appLink);
            setCopied(true);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                flexDirection: isBrowser ? 'row' : 'column',
            }}
        >
            <a
                href={appLink}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.boto_app}
            >
                Obrir a l'app 📱
            </a>

            <div style={{ position: 'relative', flex: 2, display: 'flex', justifyContent: 'center' }}>
                <input
                    onClick={(e) => e.target.select()}
                    type="text"
                    value={appLink}
                    style={styles.input_app}
                    readOnly
                />

                { isBrowser && <button
                    onClick={copyToClipboard}
                    style={{
                        position: 'absolute',
                        right: 4,
                        top: '60%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#e8f0ff',
                        border: '1px solid #b8c7e6',
                        borderRadius: '4px',
                        fontSize: '12px',
                        padding: '5px',
                        cursor: 'pointer',
                        color: 'black'
                    }}
                >
                    {copied ? 'Copiat!' : 'Copiar'}
                </button> }
            </div>
        </div>
    );
}

function Check({ event_id, setIgnoredEvents }) {
    return (
        <Pressable
            onClick={() => {
                setIgnoredEvents(prev => ({ ...prev, [event_id]: true }))
            }}
            style={{
                position: 'absolute',
                top: 25,
                right: 25,
            }}
        >
            ✅
        </Pressable>
    )
}

function Event(props) {
    const defaultHoraInici = applyTimeZone(props['data-inici'])

    const [caixesCastellers, setCaixesCastellers] = useState({});
    const [allPosicions, setAllPosicions] = useState({});
    const [order, setOrder] = useState(false);
    const [assistencies, setAssistencies] = useState([]);
    const [proves, setProves] = useState({ 'event': -1, 'private': [], 'public': [], 'admin': [] });
    const [horaInici, setHoraInici] = useState(defaultHoraInici);
    const [troncsModalOpen, setTroncsModalOpen] = useState(false);
    const horesProves = calculateProvesHores(proves, order, props.durations, horaInici)

    return (
        <div className={props.past ? 'past-event' : ''} style={{...styles.event_content, ...{ backgroundColor: props.past ? 'rgb(245, 255, 245)' : 'white' }, ...(
            props.isModels ? {
                borderStyle: 'solid',
                borderWidth: 1,
                borderColor: 'black',
            } : {}
        )}}>
            { props.past && <Check {...props} /> }

            <div style={styles.event_info}>
                {
                    !props.isModels && <HideButton {...props} />
                }
                <Info {...props} />
                {
                    props.isModels ? null : <>
                        <ResumAssistencia {...props} assistencies={assistencies} />
                        <BotoProjector {...props} />
                        <BotoMobileAppLink {...props} />
                        {props.userInfo && can(props.userInfo, 'EDIT_TRONCS') && (
                            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                <button
                                    onClick={() => setTroncsModalOpen(true)}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#2859A8',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        flex: 1,
                                        fontSize: '14px',
                                    }}
                                >
                                    📊
                                    Editar els troncs
                                </button>
                            </div>
                        )}
                        <ResumTroncs
                            data={caixesCastellers}
                            order={order}
                            assistencies={assistencies}
                            horesProves={horesProves}
                            {...props}
                        />
                        {hasNuclisSummaryFeature(COLLA) && (
                            <ResumNuclis
                                data={caixesCastellers}
                                order={order}
                                assistencies={assistencies}
                                horesProves={horesProves}
                                allPosicions={allPosicions}
                                {...props}
                            />
                        )}
                    </>
                }
            </div>
            <div style={styles.event_proves}>
                <LlistaProves
                    proves={proves}
                    setProves={setProves}
                    horaInici={horaInici}
                    setHoraInici={setHoraInici}
                    caixesCastellers={caixesCastellers}
                    setCaixesCastellers={setCaixesCastellers}
                    allPosicions={allPosicions}
                    setAllPosicions={setAllPosicions}
                    order={order}
                    setOrder={setOrder}
                    assistencies={assistencies}
                    setAssistencies={setAssistencies}
                    {...props}
                />
            </div>

            <Popup 
                closed={!troncsModalOpen} 
                setClosed={(value) => setTroncsModalOpen(!value)} 
                width="90%"
            >
                <WebAppTroncs
                    event={props.event}
                    socket={props.socket}
                    castellersInfo={props.castellersInfo}
                    bundlesInfo={props.bundlesInfo}
                    userInfo={props.userInfo}
                />
            </Popup>
        </div>
    );
}

export default Event;
